export default __webpack_public_path__ + "static/security-audit-cbe7459c1662d9e8f6d8a706c04a9d04.jpg";